
	export default {
		computed: {
			loading () {
				return this.$store.state.loading
			}
		}
	}
